(function () {

    "use strict";

    function mainController(loginService, $state) {

        $state.go("/");
        loginService.externalLogin();
    }

    mainController.$inject = ["sphForms.loginService", "$state"];

    angular.module("sphforms.main").controller("MainController", mainController);

}());

